import YapWebSocketClient from './yapWebSocketClient';

export default class YapDeviceWebSocketClient extends YapWebSocketClient {
    constructor(assetId, createNew = false, options) {
        super(assetId, createNew, options, 'YapDeviceWebSocketClient');
    }
}
